import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IncotermsLookupModel } from 'app/generated/backend/trade/api/incoterms-lookup-model';

@Injectable()
export class IncotermsLookupHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
	): Observable<JsonResourceResponse<IncotermsLookupModel[]>> {
		return this.http.get<JsonResourceResponse<IncotermsLookupModel[]>>('api/v1/trade/incoterms/lookup').pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		IncotermsLookupHandlerService
	]
})
export class IncotermsLookupHandlerModule { }
